import { useEffect } from "react";

function youTubeId(url: string): string | null {
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/))([\w-]{11})/);
  return m ? m[1] : null;
}

export function VideoEmbed({ url, autoPlay = true }: { url: string; autoPlay?: boolean }) {
  const yt = youTubeId(url);
  if (yt) {
    return (
      <iframe
        className="absolute inset-0 w-full h-full"
        src={`https://www.youtube.com/embed/${yt}?rel=0${autoPlay ? "&autoplay=1" : ""}`}
        allow="accelerometer; autoplay; encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen
        title="Video"
      />
    );
  }
  return <video src={url} controls playsInline autoPlay={autoPlay} preload="metadata" className="absolute inset-0 w-full h-full bg-black" />;
}

export default function VideoPlayerModal({ url, title, onClose }: { url: string; title: string; onClose: () => void }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-[70] bg-black/70 flex items-center justify-center p-4" onClick={onClose} role="dialog" aria-modal="true" aria-label={title}>
      <div className="w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between gap-3 mb-2 text-white">
          <div className="font-heading font-bold text-sm truncate">{title}</div>
          <button onClick={onClose} aria-label="Cerrar" className="w-8 h-8 rounded-full bg-white/15 hover:bg-white/25 cursor-pointer flex items-center justify-center">
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
        <div className="relative w-full rounded-xl overflow-hidden bg-black" style={{ aspectRatio: "16 / 9" }}>
          <VideoEmbed url={url} />
        </div>
      </div>
    </div>
  );
}
